import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const LoginButton = () => (
  <a href="/auth/google">
    <Button color="google plus" floated="right">
      <Icon name="google" />
      Entrar com Google
    </Button>
  </a>
);

export default LoginButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/LoginButton.js